import { render } from "./shareCard.vue?vue&type=template&id=d918e9b8&scoped=true"
import script from "./shareCard.vue?vue&type=script&lang=js"
export * from "./shareCard.vue?vue&type=script&lang=js"

import "./shareCard.vue?vue&type=style&index=0&id=d918e9b8&lang=scss&scoped=true"

import exportComponent from "E:\\collectionactivities\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d918e9b8"]])

export default __exports__